////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import convertHexToRGBA from '../../../helpers/HexToRgba'

//////STYLED//////
const SalesHistoryPaymentStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => convertHexToRGBA(props.colorCode, 0.2)};
	color: ${(props) => props.colorCode};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
`
//////STYLED//////

const SalesHistoryPaymentStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<SalesHistoryPaymentStatusWrapper colorCode={props.row.paymentStatus.colorCode}>
			{translations[props.row.paymentStatus.translationKey]}
		</SalesHistoryPaymentStatusWrapper>
	)
}

SalesHistoryPaymentStatus.propTypes = {}

SalesHistoryPaymentStatus.defaultPropTypes = {}

export default SalesHistoryPaymentStatus
